<template>
    <div class="alibaba-report">
        <div class="main-button-bar">
            <sn-user-search-input
                title="员工名称"
                class="search-item"
                @change="
              (a) => {
                condition.userId = a;
              }
            "
            ></sn-user-search-input>

            <el-date-picker
                type="date"
                placeholder="统计时间（开始）"
                v-model="condition.reportDateStart"
                class="search-item"
                value-format="yyyy-MM-dd"
            ></el-date-picker>

            <el-date-picker
                type="date"
                placeholder="统计时间（截止）"
                v-model="condition.reportDateEnd"
                class="search-item"
                value-format="yyyy-MM-dd"
            ></el-date-picker>

            <el-button type="primary" size="small" @click="SearchBycondition()">搜索</el-button>
        </div>

        <div
            :style="'height:' + (this.$tools.mainHeight() - 61) + 'px;'"
            v-infinite-scroll="next"
            :infinite-scroll-disabled="disabled()"
            infinite-scroll-delay="1000"
            class="daily-box"
        >
            <el-card class="daily-item box-card" v-for="(item, i) in records" :key="i">
                <div class="daily-title">
                    <span>{{item.userName}} {{$tools.timestampToDay(item.reportDate)}} 日报</span>
                </div>
                <pre class="daily-content">{{item.content}}</pre>
                <div class="daily-createTime">{{$tools.timestampToTime(item.createTime)}} 创建</div>
            </el-card>

            <div class="daily-more">
                <p v-if="!disabled()">加载中....</p>
                <p v-if="disabled()">没有更多了...</p>
            </div>
        </div>
    </div>
</template>

<script>
import SnUserSearchInput from "../components/SnUserSearchInput.vue";
export default {
    components: { SnUserSearchInput },
    data() {
        return {
            params: {},
            status: [
                "订单关闭",
                "订单完成",
                "待买家付款",
                "待卖家接单",
                "待卖家确认订单",
                "待买家支付预付款",
                "待买家支付尾款",
                "待买家确认已修改的合同",
                "待卖家确认尾款金额",
                "待卖家发货",
                "待买家确认收货",
                "发货中",
            ],
            records: [],
            condition: {},
        };
    },
    methods: {
        disabled() {
            return (
                this.params.current >= this.params.pages ||
                this.params.total == 0
            );
        },
        next() {
            this.params.current = (this.params.current ? this.params.current : 0) + 1;
            this.search();
        },
        search() {
            let _this = this;

            _this.$http.post(
                ["daily/page", _this.params, _this.condition],
                [
                    function (data) {
                        _this.params.pages = data.pages;
                        _this.params.total = data.total;
                        _this.records = _this.records.concat(data.records);
                    },
                    function () {
                        _this.params.total = 0;
                    },
                ],
                ".daily-box"
            );
        },
        SearchBycondition() {
            this.records = [];
            this.search();
        },
    },
};
</script>

<style lang="scss">
.daily-box {
    overflow-y: auto;

    .daily-item {
        float: left;
        margin: 1%;
        width: 31%;
    }

    .daily-more {
        clear: both;
        text-align: center;
        font-size: 14px;
        color: #c0c4cc;
    }

    .daily-createTime {
        text-align: right;
        margin-right: 10px;
        font-size: 12px;
        color: #c0c4cc;
    }

    .daily-title {
        color: #c0c4cc;
    }

    .daily-content {
        height: 200px;
        overflow: auto;
        padding: 5px 0;
    }
}

.el-card__body {
    padding: 10px !important;
}
</style>